
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import ExtraPaidCustomer from "../components/advancePaidCustomer";
import Footer from "../components/footer";

function ExtraPaidCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < ExtraPaidCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default ExtraPaidCustomerPage;